import { Calendar, Select } from "@/storybook-components";
import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { DateQuestionProps } from "../types";

export const DateQuestion = (props: DateQuestionProps) => {
  const {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    className,
    layoutProps,
    questionId,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    placeholder,
    isDisabled,
    handleChange,

    size,
    isYearOnlyDate,
    isClearable = true,
    isSearchable = false,
    contentClassName,
    menuPlacement,
    options,
    locale,
    dateFormat,
    isInsideIframe,
    answerProps,
    answerAriaLabel,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps
  } = props;

  const headerFooterProps = {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    questionId,
    className,
    layoutProps,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        {isYearOnlyDate ? (
          <Select
            id={questionId}
            isClearable={isClearable}
            size={size}
            value={answer}
            menuPlacement={menuPlacement}
            isSearchable={isSearchable}
            onChange={handleChange}
            classNamePrefix="ehq-dropdown"
            className={contentClassName}
            placeholder={placeholder}
            options={options}
            {...answerProps}
          />
        ) : (
          <Calendar
            id={questionId}
            disabled={isDisabled}
            onChange={handleChange}
            className={contentClassName}
            size={size}
            selected={answer ? new Date(answer) : null}
            locale={locale}
            placeholderText={placeholder}
            dateFormat={dateFormat}
            ariaLabel={answerAriaLabel}
            isInsideIframe={isInsideIframe}
            {...answerProps}
          />
        )}
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
